import { Node, mergeAttributes } from '@tiptap/core';

/**
 * A block-level, atomic `page_break` node. It carries no content and serializes
 * to the ProseMirror JSON `{ type: 'page_break' }` that the server renderer
 * (DocumentGeneration::ProsemirrorRenderer) maps to `<div class="page-break">`
 * (CSS `break-after: page`), so WeasyPrint starts the following content on a new
 * PDF page. In the editor it renders as a labelled dashed divider on the paper
 * canvas (styled by `.page-break` in template-editor.css).
 */
export const PageBreak = Node.create({
  name: 'page_break',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  parseHTML() {
    return [{ tag: 'div.page-break' }, { tag: 'div[data-page-break]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        class: 'page-break',
        'data-page-break': 'true',
      }),
    ];
  },

  addCommands() {
    return {
      insertPageBreak:
        () =>
        ({ chain }) =>
          chain()
            .insertContent({ type: this.name })
            .run(),
    };
  },
});

export default PageBreak;
